import React from "react";

const TermsModal = (props) => {
  return (
    <div className="terms-modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="terms-modal">
        <section className="modal-head">
          <h1>{props.ModalTitle}</h1>
          <i onClick={() => props.Close()} className="feather-x"></i>
        </section>
        <div className="modal-body">
          <p>{props.Text}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
